import log from "loglevel";
import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CommonPage, ErrorBoundary, ScrollToTop } from "@components/common";
import { FootnotesProvider } from "@features/footnotes";
import { isTestStage } from "@common/env";

import { CustomRouter } from "@components/CustomRouter/CustomRouter";
import { createBrowserHistory } from "history";
import { LoadingPage } from "@product-pages/pages";
import LandingPage from "@products/necst-ratenkredit/wizard-pages/LandingPage";
import { JourneyRoutes } from "@common/models/enums";
import { useTranslation } from "react-i18next";
import { WizardPage } from "@product-pages/components/wizard";
import ErrorBasePage from "@product-pages/pages/ErrorBasePage";
import { LicensesPage } from "@product-pages/pages";

log.setLevel(isTestStage() ? "DEBUG" : "ERROR", false);

export const history = createBrowserHistory();

const App = () => {
  const { t } = useTranslation();
  const [allReady, setAllReady] = React.useState(false);
  useEffect(() => {
    setAllReady(true);
  }, []);
  const Body = ({ spinner = false }: any) => (
    <div className="o-root">
      <CustomRouter history={history}>
        <ErrorBoundary>
          <FootnotesProvider>
            <ScrollToTop>
              {allReady ? (
                <React.Suspense
                  fallback={spinner ? <LoadingPage /> : <CommonPage />}
                >
                  <Routes>
                    <Route
                      path={JourneyRoutes.LANDING_PAGE}
                      element={
                        <WizardPage
                          page={
                            <LandingPage
                              stepIndex={0}
                              title={t("landing:wizard:title")}
                              path={JourneyRoutes.LANDING_PAGE}
                              indexable
                            />
                          }
                          noFunctionalSteps={t("landing:noFunctionalSteps", {
                            returnObjects: true,
                          })}
                          currentStepIndex={0}
                          firstStepPath={JourneyRoutes.LANDING_PAGE}
                        />
                      }
                    />
                    <Route
                      path={JourneyRoutes.LICENSES}
                      element={<LicensesPage />}
                    />
                    <Route
                      path={JourneyRoutes.ERROR}
                      element={<ErrorBasePage />}
                    />
                    <Route
                      path="*"
                      element={
                        <Navigate to={JourneyRoutes.ERROR} replace={true} />
                      }
                    />
                  </Routes>
                </React.Suspense>
              ) : spinner ? (
                <LoadingPage />
              ) : (
                <CommonPage />
              )}
            </ScrollToTop>
          </FootnotesProvider>
        </ErrorBoundary>
      </CustomRouter>
    </div>
  );

  return <Body spinner />;
};

export default App;
